import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Alert, Button, FormControl, InputLabel, MenuItem, Select, Snackbar, TableHead, TextField, useTheme } from "@mui/material";
import { primarycolor } from "../Utils/colors";
import { FaPlus } from "react-icons/fa";
import Loadingspinner from "../Components/loading";
import axios from "axios";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { getcolor, getpaymentcolor } from "../Utils/functions";
import { getsessionuser } from "../Utils/sessions";
import { Fetchtransactionsurl } from "../Utils/urls";

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}



const Transactions = ({ oncancelfund,wallet }) => {

    const user = getsessionuser()
    const [loading, setloading] = useState(false);
    const [refreshdata, setrefreshdata] = useState('');
    const [error, seterror] = useState('');

    const [totalamount, settotalamount] = useState('0');
    const [transactions, settransactions] = useState([]);


    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const [displayedtransactions, setdisplayedtransactions] = useState([]);
    //search states
    const [transid, settransid] = useState('');


    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - displayedtransactions.length) : 0;

    const handleChangePage = (event, newPage,) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const textinputstyles = {
        maxHeight: 20,
        marginRight: 5,
        width: 200,
        marginBottom: 5,
        fontSize: 10
    }

    useEffect(() => {
        fetchtransactions()
    }, [refreshdata]);
    const fetchtransactions = () => {
        setloading(true)
        axios.post(Fetchtransactionsurl, {
            phone: user?.phone,
        }).then(function (response) {
            setloading(false)
            if (!response.data.message) {
                settransactions(response.data)
                setdisplayedtransactions(response.data)
                settotalamount(response.data.map(order => order.amount).reduce((acc, amount) => parseInt(acc) + parseInt(amount)))
            } else {
                seterror(response.data.message);
            }
            // 
        }).catch(function (error) {
            setloading(false)
            seterror("Sorry there was an error try again later")
            //if(error.response.status === 401 || error.response.status === 400){}

        });
    }





    const Searchlogic = () => {//serch transactions that have already been fetched
        var result = [];
        transactions.forEach(element => {
            if (element.transid === parseInt(transid)) {
                result.push(element)
            }
        });
        return result;
    }

    //search transactions
    const searchtransactions = () => {
        if (!transid) {
            setdisplayedtransactions(transactions)
        } else {
            const gottendata = Searchlogic()
            if (gottendata.length > 0) {
                settotalamount(gottendata.map(order => order.amount).reduce((acc, amount) => parseInt(acc) + parseInt(amount)))
                setdisplayedtransactions(gottendata)
            } else {
                settotalamount(0)
                setdisplayedtransactions([])
                seterror("no transactions matches the search query")
            }
        }
    }





    return (
        <Container sx={{
            backgroundColor: "white",
            marginTop: 5,
            padding: 4,
        }} maxWidth="lg">
            <Snackbar open={error?.length > 0 && true} autoHideDuration={3000} onClose={() => seterror()}>
                <Alert severity="error">{error}</Alert>
            </Snackbar>
            {loading && <Loadingspinner />}
            <div className="routepathwrap">
                <div className="routepathmain">Transactions</div>
                <div className="routepathminor"> / All transactions</div>
            </div>
            <Container maxWidth="lg" className="containerwithshadow" style={{ marginTop: 10 }}>
                <div className="numberswrap">
                    <div className="numberdiv">
                        <div style={{ display: "flex", alignItems: 'center', justifyContent: "center" }}>
                            <div style={{ fontWeight: "bold" }}>{totalamount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
                        </div>
                        <div style={{ fontSize: 12 }}>Total</div>
                    </div>
                    <div className="numberdiv">
                        <div style={{ display: "flex", alignItems: 'center', justifyContent: "center" }}>
                            <div style={{ fontWeight: "bold" }}>{wallet.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
                        </div>
                        <div style={{ fontSize: 12 }}>Wallet balance</div>
                    </div>
                </div>
            </Container>
            <Container maxWidth="lg" className="containerwithshadow" style={{ marginTop: 20 }}>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    <TextField id="outlined-basic" sx={textinputstyles} label="Transactions ID" variant="outlined" size="small" value={transid} onChange={(e) => settransid(e.target.value)} />

                    <Button variant="contained" onClick={() => searchtransactions()} sx={{ background: primarycolor, height: 40, marginRight: 3 }}>Search</Button>
                    <Button variant="outlined" sx={{ height: 40 }}>Export</Button>
                </div>
            </Container>
            <Container maxWidth="lg" className="containerwith" style={{ marginTop: 20 }}>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="custom pagination table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: "bold" }}>Transaction Id </TableCell>
                                <TableCell sx={{ fontWeight: "bold" }} align="right">Phone</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }} align="right">Transaction Time</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }} align="right">Transaction Date</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }} align="right">Amount</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(rowsPerPage > 0
                                ? Array.isArray(displayedtransactions) && displayedtransactions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : displayedtransactions
                            ).map((row, key) => {

                                return (
                                    <TableRow key={key}>
                                        <TableCell component="th" scope="row"> {row.transid}</TableCell>
                                        <TableCell style={{ width: 160 }} align="right"> {row.phone}</TableCell>
                                        <TableCell style={{ width: 160 }} align="right"> {row.time} </TableCell>
                                        <TableCell style={{ width: 160 }} align="right">  {row.date} </TableCell>
                                        <TableCell style={{ width: 160 }} align="right">  {row.amount} </TableCell>
                                    </TableRow>)
                            })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 53 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                    colSpan={12}
                                    count={displayedtransactions.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        inputProps: {
                                            'aria-label': 'rows per page',
                                        },
                                        native: true,
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>
            </Container>
        </Container>
    )
}

export default Transactions
